import React, { useContext } from "react";
import BounceLoader from "react-spinners/BounceLoader";
import cn from "classnames";

import { SubmitButtonProps } from "./SubmitButton.props";
import Button from "../../Button";
import { FormContext } from "../../Form";
import styles from "./SubmitButton.module.scss";

/**
 * @deprecated Use `import { SubmitButton } from capitalrx-components-2.0/lib/forms` instead.
 */
const SubmitButton: React.FC<SubmitButtonProps> = (props: SubmitButtonProps): JSX.Element | null => {
  const {
    id,
    testId,
    className,
    disabled,
    icon,
    size,
    color = "turquoise",
    fullWidth,
    children,
    tier,
    iconLocation = "left",
    isSubmitting = false,
    isLoading,
  } = props;

  const { readOnly, formState } = useContext(FormContext);
  const { isSubmitting: isFormSubmitting, isFormLoading } = formState;

  const submitClasses = cn(
    styles["submit-button"],
    { [styles["has-icon"]]: children && icon },
    { [styles["icon-only"]]: !children && icon },
    { [styles["form-submitting"]]: isSubmitting || isFormSubmitting },
    className,
  );

  const loaderColor = () => {
    if (tier === "secondary" || tier === "tertiary") {
      return "#0071B3";
    }

    return "white";
  };

  if (!readOnly) {
    return (
      <Button
        id={id}
        testId={testId}
        className={submitClasses}
        disabled={disabled || isLoading || isFormLoading}
        fullWidth={fullWidth}
        icon={icon}
        size={size}
        color={color}
        tier={tier || "primary"}
        type="submit"
        iconLocation={iconLocation}
      >
        <BounceLoader color={loaderColor()} loading={isSubmitting || isFormSubmitting} className="bounce-loader" size={24} />
        {children}
      </Button>
    );
  }

  return null;
};

/**
 * @deprecated
 */
export default SubmitButton;

/**
 * @deprecated
 */
export { BounceLoader } from "react-spinners";
